import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/img/svg/success-modal-img.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "check-icon"
}, null, -1)

import AppModal from "@/components/slots/modals/AppModal.vue";
import AppModalTitle from "@/components/slots/modals/AppModalTitle.vue";
import { useI18n } from "vue-i18n";
import AppModalImage from "@/components/slots/modals/AppModalImage.vue";
import { useTransactionStore } from "@/stores/transaction";
import AppBtn from "@/components/slots/buttons/AppBtn.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SendTransactionModal',
  setup(__props) {

const { t } = useI18n();
const transaction = useTransactionStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AppModal, {
    onClose: _cache[1] || (_cache[1] = ($event: any) => {
      _unref(transaction).setIgnoreStateMutation(false);
      _unref(transaction).setSendTransactionResponse(null);
    })
  }, {
    default: _withCtx(() => [
      _createVNode(AppModalImage, null, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }),
      _createVNode(AppModalTitle, { class: "popup__title" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("send-transaction-modal-phrase-1")), 1)
        ]),
        _: 1
      }),
      _createVNode(AppBtn, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => {
        _unref(transaction).setIgnoreStateMutation(false);
        _unref(transaction).setSendTransactionResponse(null);
      })
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("two-fa-phrase-15")), 1)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})